import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SubSink } from 'subsink';
import { RouterPathConfig } from '../../constants/router-path.config';
import { USER_ROLE } from '../../constants/user-role.enum';
import { ViewDetails } from '../../models/view-details.model';
import { LoggedInUserService } from '../../services/logged-in-user.service';
import { RoutingHandlerService } from '../../services/routing-handler.service';
import { SidebarMenuService } from '../../services/sidebar-menu.service';

@Component({
    selector: 'app-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss', './sidebar-menu.responsive.component.scss']
})
export class SidebarMenuComponent implements OnDestroy, OnChanges, OnInit {
    @Input() sideMenuList: ViewDetails[] = [];
    @Input() screenSize: string;
    showMobileMenu: boolean = false;
    allSection: boolean = true;
    showMenu: boolean = true;
    activeMenuItem: ViewDetails;
    userRole: string;
    USER_ROLE = USER_ROLE;
    userPath: string;
    callRecordMenuItem = [];
    dashboardMenuItems = [];
    filteredMenuList = [];
    subs = new SubSink();
    delegationMenuError: string = '';
    isLoadingDelegationMenu: boolean = false;

    sectionsList = [
        { viewValue: 'test', value: 'test' },
        { viewValue: 'test2', value: 'test2' }
    ];

    constructor(
        private sidebarMenuService: SidebarMenuService,
        private loggedInUserService: LoggedInUserService,
        private routingHandlerService: RoutingHandlerService
    ) {}

    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        this.handleSideMenu();
        this.getUserRole();
        this.getUserUrlPath();
        this.subscribeToActivateMenuItem();
        this.allSection = true;
    }

    handleSideMenu() {
        this.filteredMenuList = [];
        this.dashboardMenuItems = [];
        this.callRecordMenuItem = [];
        if (this.sideMenuList && this.sideMenuList.length > 0) {
            this.sideMenuList.forEach(item => {
                if (item.path === 'callRecord') {
                    this.callRecordMenuItem.push(item);
                } else if (item.path === 'dashboard' || item.path === 'callRecordDashboard') {
                    this.dashboardMenuItems.push(item);
                } else {
                    this.filteredMenuList.push(item);
                }
            });
        }
    }

    getUserRole() {
        this.userRole = this.loggedInUserService.getUserRole();
    }

    public isSuperAdmin(): boolean {
        return this.loggedInUserService.isSuperAdmin();
    }

    getUserUrlPath() {
        const activeHeaderMenu = this.sidebarMenuService.getActiveHeaderMenuItem();
        if (activeHeaderMenu && activeHeaderMenu.id === 4) {
            this.userPath = RouterPathConfig.DATA_MANAGEMENT;
        } else if (activeHeaderMenu && activeHeaderMenu.id === 10) {
            this.userPath = RouterPathConfig.FILE_MANAGEMENT;
        } else if (activeHeaderMenu && activeHeaderMenu.id === 11) {
            this.userPath = RouterPathConfig.PERIODIC_REVIEW;
        } else if (activeHeaderMenu && activeHeaderMenu.id === 15) {
            this.userPath = RouterPathConfig.DELEGATION;
        } else {
            this.userPath = this.routingHandlerService.getUserPathFromRole(this.userRole);
        }
    }

    showMenufunction(value) {
        if (value == true) {
            this.showMenu = true;
            this.showMobileMenu = true;
        } else {
            this.showMenu = false;
            this.showMobileMenu = false;
        }
    }

    subscribeToActivateMenuItem() {
        const iconMapping = {
            'sharedfiles.svg': 'mobileShareIcon.svg',
            'storageunit.svg': 'mobileStorageUnit.svg',
            'activity.svg': 'mobileActivityIcon.svg',
            'deletedfiles.svg': 'mobileDeleteIcon.svg'
        };

        this.subs.sink = this.sidebarMenuService.updateActiveItem.subscribe((indexToActivate: number) => {
            if (this.sideMenuList?.length > 0) {
                this.activeMenuItem = this.sideMenuList[indexToActivate];
            }
            // Check if the screen width is less than 575px
            if (window.innerWidth < 575 && iconMapping[this.activeMenuItem.icon]) {
                this.activeMenuItem.icon = iconMapping[this.activeMenuItem.icon];
            }
        });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
